import React from "react";
import prop from "ramda/src/prop";
import sortBy from "ramda/src/sortBy";
import EditorAddIcon from "@atlaskit/icon/glyph/editor/add";

import { Button } from "../../UI/Button";
import { EnhancedTable } from "../EnhancedTable";
import { EnhancedTableBody } from "../EnhancedTableBody";
import { useNetwork } from "../../hooks/useNetwork";
import { useModalContext } from "../../contexts/ModalContext/context";
import { GenderGroupsTableRow } from "./GenderGroupsTableRow";
import { ModalProvider } from "../../contexts/ModalContext";
import { ReadOnlyWrapper } from "../ReadOnlyWrapper";
import { Grid } from "../../UI/Grid";
import { TableHead } from "../../UI/TableHead";
import { TableRow } from "../../UI/TableRow";
import { TableCell } from "../../UI/TableCell";
import useAuth from "../../routes/login/AuthContext";

interface IProps {
  subnetwork: number;
  isDisabled?: boolean;
}

export const GenderGroupsTable: React.FC<IProps> = (props) => {
  const { getL2, selectedNetwork } = useNetwork();
  const { setIsOpen } = useModalContext();
  const { isSuperAdminRead } = useAuth();

  const l2 = getL2(selectedNetwork.l1Id, props.subnetwork);

  const matchingGroups = l2?.genderNetworkSettingsTransport.genderGroups || [];

  const handleAddMatchingOption = () => {
    setIsOpen(true);
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <EnhancedTable
          title="Gender Groups"
          titleHelpTooltip="If a group can match with 'All Groups', this means that users from all other groups can also view and match with them, regardless of their own group settings."
        >
          <TableHead secondary>
            <TableRow>
              <TableCell>Gender Group</TableCell>
              <TableCell> Can Match With All </TableCell>
              <TableCell> Can View All </TableCell>
              <TableCell />
            </TableRow>
          </TableHead>
          <EnhancedTableBody colSpan={4}>
            {sortBy(prop("id"), matchingGroups).map((group) => (
              <ModalProvider key={group.id}>
                <GenderGroupsTableRow subnetwork={props.subnetwork} {...group} isDisabled={props.isDisabled}/>
              </ModalProvider>
            ))}
          </EnhancedTableBody>
        </EnhancedTable>
      </Grid>
      <Grid item xs={12}>
        <ReadOnlyWrapper>
          <Button
            appearance="primary"
            onClick={handleAddMatchingOption}
            iconBefore={<EditorAddIcon label="Plus" />}
            isDisabled={isSuperAdminRead() || props.isDisabled}
          >
            Add Gender Group
          </Button>
        </ReadOnlyWrapper>
      </Grid>
    </Grid>
  );
};
